import React from 'react';

import * as S from './styles';

function Heart() {
  return <S.Tiheart />;
}

export default Heart;